import React from "react";

// Letisztult tető-embléma: kettős tetővonal (ács/fedés) + kéménybekötés-jel (bádogos).
export function LogoMark({ size = 44, accent = "var(--gold)" }) {
  const stroke = Math.max(1.8, size * 0.05);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 44 44"
      fill="none"
      aria-hidden="true"
      style={{ display: "block", flexShrink: 0 }}
    >
      {/* éles keret */}
      <rect x="1.5" y="1.5" width="41" height="41" stroke={accent} strokeWidth="1" opacity="0.4" />
      {/* külső tetővonal */}
      <path d="M7 25 L22 11 L37 25" stroke={accent} strokeWidth={stroke} strokeLinejoin="miter" />
      {/* belső eresz-réteg */}
      <path d="M12 31 L22 21.5 L32 31" stroke={accent} strokeWidth={stroke} strokeLinejoin="miter" opacity="0.5" />
      {/* kémény / bádogos jel */}
      <rect x="28" y="12.5" width="3.4" height="6.5" fill={accent} />
    </svg>
  );
}

export default function Logo({
  height = 52,
  color = "var(--text)",
  accent = "var(--gold)",
  showTagline = true,
}) {
  const markSize = Math.round(height * (showTagline ? 0.92 : 0.86));
  const nameSize = Math.round(height * (showTagline ? 0.34 : 0.42));
  const tagSize = Math.max(8, Math.round(height * 0.14));
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: Math.round(height * 0.24) }}>
      <LogoMark size={markSize} accent={accent} />
      <span style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
        <span
          style={{
            fontFamily: "Manrope, sans-serif",
            fontWeight: 700,
            fontSize: nameSize,
            letterSpacing: "0.04em",
            color,
            textTransform: "uppercase",
          }}
        >
          Totál-Bádogos
        </span>
        {showTagline && (
          <span
            style={{
              marginTop: Math.round(height * 0.13),
              fontFamily: "Inter, sans-serif",
              fontWeight: 600,
              fontSize: tagSize,
              letterSpacing: "0.26em",
              color: accent,
              textTransform: "uppercase",
            }}
          >
            Kft.
          </span>
        )}
      </span>
    </span>
  );
}
